<!-- @format -->

<div class="contextual-notification {{ variant }}">
  <sis-icon *ngIf="icon" [icon]="icon" aria-hidden="true"></sis-icon>
  <div class="content-text">
    <span class="visually-hidden">{{ ariaVariantText | translate }}</span>
    {{ content }}
    <ng-content></ng-content>
  </div>
</div>
